export const PREV = 'prev'
export const NEXT = 'next'
